// @flow
import React, { Component } from "react";

type Props = {};
type State = {};
class NotFoundPage extends Component<Props, State> {
	render() {
		return <div>404: Page not found.</div>;
	}
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js